/**
 * Budget Service
 * Register Angular Services for Budget Jars
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('Budget', ['$resource', function($resource){
    return $resource('/api/v2/budget/:id');
}]);
